/** Remove a duplicated German court prefix before localized presentation. */
export function normalizeRegisterCourt(
  registerCourt: string | null | undefined,
): string | null {
  const court = (registerCourt || '').replace(/^Amtsgericht\s+/i, '').trim();
  return court || null;
}

/** Format the separately stored register type and number for display.
 *  Swiss UIDs ("CHE-…") and Firmenbuchnummern ("FN 359363a") name their
 *  register themselves, so the internal type is dropped. `includeSwissType`
 *  keeps the lists that always showed "CH-HR CHE-…" unchanged; an Austrian
 *  number never gets the "AT-FB" prefix. */
export function formatRegisterNumber(
  registerType: string | null | undefined,
  registerId: string | null | undefined,
  includeSwissType = false,
): string | null {
  const id = registerId?.trim();
  if (!id) return null;
  return (registerType === 'CH-HR' && !includeSwissType) ||
    registerType === 'AT-FB'
    ? id
    : registerType
      ? `${registerType} ${id}`
      : id;
}
